// state
export const state = {}

// getters
export const getters = {}

// mutations
export const mutations = {}

// actions
export const actions = {

    // example
    async testSuccess({commit, dispatch}, params) {
        dispatch('loading/addLoading', '', {root: true})
        const {data} = await axios.get('/api/v1/student/test-success', {params: params});
        dispatch('loading/subLoading', '', {root: true})
    },
    // example
    async testErrorValidation({commit, dispatch}, params) {
        dispatch('loading/addLoading', '', {root: true})
        const {data} = await axios.get('/api/v1/student/test-error-validation', {params: params});
        dispatch('loading/subLoading', '', {root: true})
    },
    // example
    async testErrorServer({commit, dispatch}, params) {
        dispatch('loading/addLoading', '', {root: true})
        const {data} = await axios.get('/api/v1/student/test-error-server', {params: params});
        dispatch('loading/subLoading', '', {root: true})
    },
}
